

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Auth Components
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyOtp from './pages/auth/VerifyOtp';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/routing/PrivateRoute';

// Customer Components
import CustomerList from './pages/customers/CustomerList';
import CustomerDetail from './pages/customers/CustomerDetail';
import CustomerForm from './pages/customers/CustomerForm';

// Prescription Components
import PrescriptionList from './pages/prescriptions/PrescriptionList';
import PrescriptionDetail from './pages/prescriptions/PrescriptionDetail';
import PrescriptionForm from './pages/prescriptions/PrescriptionForm';

// Invoice Components
import InvoiceList from './pages/invoices/InvoiceList';
import InvoiceDetail from './pages/invoices/InvoiceDetail';
import InvoiceForm from './pages/invoices/InvoiceForm';

// User Components
import UserList from './pages/users/UserList';
import UserForm from './pages/users/UserForm';
import Profile from './pages/Profile';

// Context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <Header />
          <main className="main-content">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              
              {/* Private Routes */}
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              
              {/* Customer Routes */}
              <Route path="/customers" element={<PrivateRoute><CustomerList /></PrivateRoute>} />
              <Route path="/customers/new" element={<PrivateRoute><CustomerForm /></PrivateRoute>} />
              <Route path="/customers/edit/:id" element={<PrivateRoute><CustomerForm /></PrivateRoute>} />
              <Route path="/customers/:id" element={<PrivateRoute><CustomerDetail /></PrivateRoute>} />
              
              {/* Prescription Routes */}
              <Route path="/prescriptions" element={<PrivateRoute><PrescriptionList /></PrivateRoute>} />
              <Route path="/prescriptions/new" element={<PrivateRoute><PrescriptionForm /></PrivateRoute>} />
              <Route path="/prescriptions/new/:customerId" element={<PrivateRoute><PrescriptionForm /></PrivateRoute>} />
              <Route path="/prescriptions/edit/:id" element={<PrivateRoute><PrescriptionForm /></PrivateRoute>} />
              <Route path="/prescriptions/:id" element={<PrivateRoute><PrescriptionDetail /></PrivateRoute>} />
              
              {/* Invoice Routes */}
              <Route path="/invoices" element={<PrivateRoute><InvoiceList /></PrivateRoute>} />
              <Route path="/invoices/new" element={<PrivateRoute><InvoiceForm /></PrivateRoute>} />
              <Route path="/invoices/new/:customerId" element={<PrivateRoute><InvoiceForm /></PrivateRoute>} />
              <Route path="/invoices/edit/:id" element={<PrivateRoute><InvoiceForm /></PrivateRoute>} />
              <Route path="/invoices/:id" element={<PrivateRoute><InvoiceDetail /></PrivateRoute>} />
              
              {/* User Routes */}
              <Route path="/users" element={<PrivateRoute adminOnly={true}><UserList /></PrivateRoute>} />
              <Route path="/users/new" element={<PrivateRoute adminOnly={true}><UserForm /></PrivateRoute>} />
              <Route path="/users/edit/:id" element={<PrivateRoute adminOnly={true}><UserForm /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            </Routes>
          </main>
          <Footer />
          <ToastContainer position="bottom-right" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
